

























import Vue from "vue";
import { marked } from "marked";
import Event from "@/classes/Event";

export default Vue.extend({
  props: {
    event: {
      type: Object as () => Event,
      required: true,
    },
  },
  computed: {
    renderedDescription(): string {
      if (!this.event.description) {
        return "";
      }
      return marked.parse(this.event.description, { async: false }) as string;
    },
  },
  methods: {
    goToRules() {
      this.$router.push("/rules");
    },
    copyEvent() {
      localStorage.setItem("copyEvent", JSON.stringify(this.event));
      this.$router.push("/events/create");
    },
  },
});
